// src/components/ContextDebugger.tsx
// Temporary component to help debug context issues

import React from 'react';

interface ContextDebuggerProps {
  context: any;
  label?: string;
  events?: any[]; // Make events optional
}

const ContextDebugger: React.FC<ContextDebuggerProps> = ({ context, label = "Context", events }) => {
  // Only show in development
  if (process.env.NODE_ENV === 'production') {
    return null;
  }

  const contextInfo = {
    exists: !!context,
    type: typeof context,
    keys: context ? Object.keys(context) : [],
    hasAllergy: context?.allergy,
    hasLink: context?.link,
    hasChecklist: context?.checklist,
    linkValue: context?.link,
    allergyValue: context?.allergy,
    checklistKeys: context?.checklist ? Object.keys(context.checklist) : [],
    // NEW: Events debugging
    eventsArray: events,
    eventsLength: events?.length || 0,
    allergyInEvents: events?.find(e => typeof e === 'string' && e.startsWith('#')),
  };

  return (
    <div style={{
      background: '#f0f0f0',
      border: '1px solid #ddd',
      padding: '10px',
      margin: '10px 0',
      borderRadius: '4px',
      fontSize: '12px',
      fontFamily: 'monospace'
    }}>
      <h4>{label} Debug Info:</h4>
      <pre>{JSON.stringify(contextInfo, null, 2)}</pre>
      {context && (
        <>
          <h5>Full Context:</h5>
          <pre style={{ maxHeight: '200px', overflow: 'auto' }}>
            {JSON.stringify(context, null, 2)}
          </pre>
        </>
      )}
    </div>
  );
};

export default ContextDebugger;